import { gsap } from '@/lib/gsap';

/**
 * Applies the hidden start state to every reveal target inside a section, one data-* contract:
 *   [data-line]    slides up inside an overflow-hidden .lm-row  (LineMask)
 *   [data-reveal]  fades and rises                              (Reveal)
 *
 * Lives in GSAP, not CSS: a stylesheet transform would be read by GSAP as a pixel offset and
 * stack on top of yPercent. Callers run this in a layout effect so nothing flashes.
 */
export function hideRevealTargets(q: gsap.utils.SelectorFunc): void {
  // Guarded: gsap.set on an empty selection logs a "target not found" warning.
  const set = (selector: string, vars: gsap.TweenVars) => {
    const targets = q(selector);
    if (targets.length) gsap.set(targets, vars);
  };
  // 140, not 100: .lm-row's clip box runs 0.3em past the line box for descenders, and the
  // glyphs' ascenders start above the line box, so a smaller offset would leave them peeking.
  set('[data-line]', { yPercent: 140 });
  set('[data-reveal]', { opacity: 0, y: 16 });
}
